import PropTypes from 'prop-types'
import React from 'react'
import { connect } from 'react-redux'
import classNames from 'classnames'

import styles from './CardImage.scss'

import BuildingCardImage from 'components/BuildingCardImage/BuildingCardImage.jsx'

import {
    checkIndustrialResource,
    checkUpgradeVisibility,
    checkBuildingsLevelSumm,
    getNecessaryBuildingsLevel,
    getBuildingsLevelSumm,
} from 'helpers/stronghold'

import {
    NECESSARY_LEVEL_MESSAGE,
    BUILDINGS_LEVEL_MESSAGE,
    BUILDINGS_LEVEL_LACKS_MESSAGE,
    MAX_LEVEL_MESSAGE,
} from './constants.jsx'

import {
    showUpgradeHighlight,
    hideUpgradeHighlight,
    openConfirmation,
} from 'state/actions/command_center_upgrade'

export class CardImage extends React.Component {
    static propTypes = {
        tooltipId: PropTypes.string.isRequired,
        isMaxCommandCenter: PropTypes.bool,
        upgradeCost: PropTypes.number,
        showUpgrade: PropTypes.bool.isRequired,
        hasEnoughIndustrialResource: PropTypes.bool.isRequired,
        hasEnoughBuildingLevelSumm: PropTypes.bool.isRequired,
        isUpgradeAvailable: PropTypes.bool.isRequired,
        strongholdLevel: PropTypes.number.isRequired,
        buildingsLevelSumm: PropTypes.number.isRequired,
        necessaryBuildingsLevel: PropTypes.number.isRequired,

        handleMouseEnter: PropTypes.func.isRequired,
        handleMouseLeave: PropTypes.func.isRequired,
        handleClick: PropTypes.func.isRequired,
    }
    componentWillUnmount() {
        this.props.handleMouseLeave()
    }
    render() {
        const {
            tooltipId,
            isMaxCommandCenter,
            upgradeCost,
            hasEnoughIndustrialResource,
            showUpgrade,
            hasEnoughBuildingLevelSumm,
            isUpgradeAvailable,
            strongholdLevel,
            buildingsLevelSumm,
            necessaryBuildingsLevel,
        } = this.props

        const buildingsLevelLacks = necessaryBuildingsLevel - buildingsLevelSumm

        const notEnoughLevel = (!hasEnoughBuildingLevelSumm && showUpgrade) ? (
            <div className={styles.notEnoughLevel}>
                <span className={styles.necessaryLevel}>
                    {NECESSARY_LEVEL_MESSAGE} <span className={styles.buildingsLevel}>{necessaryBuildingsLevel}</span>
                </span>
                <span className={styles.levelIllustration}>
                    {'('}
                    {BUILDINGS_LEVEL_MESSAGE} <span className={styles.buildingsLevel}> {buildingsLevelSumm}</span>{', '}
                    <span className={styles.levelLacks}>{BUILDINGS_LEVEL_LACKS_MESSAGE}</span>
                    <span className={styles.buildingsLevel}> {buildingsLevelLacks}</span>
                    {')'}
                </span>
            </div>
        ) : null

        const buildingType = 'COMMAND_CENTER'
        const buildingLevel = strongholdLevel
        const innerProps = {
            buildingType,
            buildingLevel,
            hasEnoughIndustrialResource,
            hasEnoughBuildingLevelSumm,
            upgradeCost,
            tooltipId: tooltipId,
            isMaxCommandCenter,
            isUpgradeAvailable,
            showUpgrade,
            onMouseEnter: this.props.handleMouseEnter,
            onMouseLeave: this.props.handleMouseLeave,
            onClick: this.props.handleClick,
        }

        const className = classNames(styles.base, {
            [styles.base__elite]: isMaxCommandCenter,
        })

        const maxLevelMessage = isMaxCommandCenter ? (
            <div className={styles.maxLevelMessage}>
                {MAX_LEVEL_MESSAGE}
            </div>
        ) : null

        return (
            <div className={className}>
                <BuildingCardImage {...innerProps} />
                {notEnoughLevel}
                {maxLevelMessage}
            </div>
        )
    }
}

export const mapStateToProps = (state, { tooltipId }) => {

    const upgradeCost = state.settings.command_center.costs[state.stronghold.level]
    const hasEnoughIndustrialResource = checkIndustrialResource(state)
    const showUpgrade = checkUpgradeVisibility(state)
    const hasEnoughBuildingLevelSumm = checkBuildingsLevelSumm(state)
    const necessaryBuildingsLevel = getNecessaryBuildingsLevel(state)
    const buildingsLevelSumm = getBuildingsLevelSumm(state)
    const isUpgradeAvailable = (
        hasEnoughIndustrialResource &&
        showUpgrade &&
        hasEnoughBuildingLevelSumm
    )

    return {
        tooltipId,
        upgradeCost,
        hasEnoughIndustrialResource,
        showUpgrade,
        hasEnoughBuildingLevelSumm,
        isUpgradeAvailable,
        necessaryBuildingsLevel,
        buildingsLevelSumm,

        strongholdLevel: state.stronghold.level,
    }
}

export const mapDispatchToProps = {
    handleMouseEnter: showUpgradeHighlight,
    handleMouseLeave: hideUpgradeHighlight,
    handleClick: openConfirmation,
}

export default connect(mapStateToProps, mapDispatchToProps)(CardImage)



// WEBPACK FOOTER //
// ./containers/CommandCenterCard/components/CardImage/CardImage.jsx